<script>
import RND from '../utils/random'
import Animator from '../utils/animator'

let TITLE = 'Кто есть кто в мире «Ходячих мертвецов»'
let TEXT = '«Спасители», группа из Хилтопа, Королевство и мусорщики'

export default {
	name: 'BadStory1',
	props: ['alpha'],
	mounted() {
		this.titleParts = TITLE.split(' ')
		this.textParts = TEXT.split(' ')

		let count = 0
		let end = 10
		Animator.add(() => {
			if (count > end) {
				this.title = this.broke(this.titleParts)
				this.text = this.broke(this.textParts)
				count = 0
				end = RND.range(10, 30)
			}
			count++
		})

	},
	data() {
		return {
			title: 'Кто &#9744;сть кт&#9744; в мире «Ход&#9744;чих мерт&#9744;ецов»',
			text: '«Спас&#9744;тели», груп&#9744;а из Хилтопа, Короле&#9744;ство Мусорщ&#9744;ки'
		}
	},
	methods: {
		broke(parts) {
			let newParts = []
			for (let i = 0; i < parts.length; i++) {
				if (parts[i].length > 1) {
					let rand = RND.range(0, parts.length - 1)
					newParts.push(parts[i].substr(0, rand) + '&#9744;' + parts[i].substr(rand + 1))
				} else {
					newParts.push(parts[i])
				}
			}
			return newParts.join(' ')
		}
	}
}
</script>



<template>
<div class="story big" :style="{opacity: alpha}">
	<video src="../assets/bad/story1.mp4" autoplay loop muted></video>
	<div class="mask">
		<h2 v-html="title"></h2>
		<p v-html="text"></p>
	</div>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.story {
	float: left;
	position: relative;
	overflow: hidden;
	background: #000;
}

.big {
	width: 50vw;
	height: 25vw;
}

video {
	width: 100%;
	transform: translateY(-15%);
	position: absolute;
}

.mask {
	width: 100%;
	height: 102%;
	position: absolute;
	background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

h2 {
	width: 90%;
	margin: 0 auto;
	font-size: 23px;
}

p {
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5vh;
	font-size: 23px;
	font-family: @fontLava;
	font-weight: 600;
	transition: all 200ms ease;
}


</style>



// WEBPACK FOOTER //
// BadStory1.vue?a387d59a